/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import InfiniteScroll from 'react-infinite-scroll-component';
import ContentItem from '../../components/ContentItem';

class MyDown extends Component {
  state = {
    gotoPage: 1,
    dataList: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;
        const dataList = result.data[0].listData;
        //console.log(con)
        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage + 1,
                con: con,
                dataList:
                  gotoPage === 1
                    ? dataList
                    : this.state.dataList.concat(dataList),
                hasMore: pageCount < gotoPage ? false : true,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                con: con,
                searchList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              con: con,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myDown',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._getData(gotoPage);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <div key={index} style={{ display: 'inline-block' }}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            onInit={this._getData}
            contentPartSerial={item.contentPartSerial}
          />
        </div>
        /*
                <div className="div_li">
                    <div className="dataList_img_bg"><img src="/img/test_img8.png"/></div>
                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                </div>
                */
      );
    });

    return list;
  };
  /*
    _onAllDelete = () => {
        const { dataList } = this.state;
        if(dataList.length <= 0) {
            toast.warn('삭제할 작품이 존재하지 안습니다.')
            return; 
        } 

        confirmAlert({ 
            title: '찜하기 전체 삭제',
            message: '찜해놓은 모든 작품을 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
            buttons: [
              
              {
                label: '모두 삭제',
                onClick: async () => {
                    const result = await this._onAllDeleteApi();
                    const intReturn = result.data[0].intReturn;

                    if(intReturn === 0) {
                        toast.success('찜한 작품이 모두 삭제 되었습니다.');
                        this._getData(1)
                    } else {
                        toast.warn('삭제할 작품이 존재하지 안습니다.')
                    }
                }
              },
              
              {
                label: '취소',
                //onClick: () => alert('Click No')
              }
            ]
        });
    }
    _onAllDeleteApi = () => {
        const { apiUrl, loginId, dataList } = this.props; 
    
        return axios.post(apiUrl + '/myZzimAllDel', {
            params: {
                userid: loginId
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  render() {
    // const { tabIndex } = this.props.childProps;
    const { hasMore, dataList, gotoPage, con } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              다운로드한 작품<span>({con})</span>
              <div></div>
            </h1>
            <div className="main_list_goup1">
              <div className="div_ul">
                <InfiniteScroll
                  dataLength={this.state.dataList.length}
                  next={() => this._getData(gotoPage)}
                  hasMore={hasMore}
                  loader={
                    <div className="vod_loading">
                      <img src={imgUrl + '/img/vod/vod_loading.png'} />
                    </div>
                  }
                  endMessage={<p style={{ textAlign: 'center' }}></p>}
                  style={{ overflow: 'hidden', textAlign: 'center' }}
                >
                  {dataList ? this._renderItem() : null}
                </InfiniteScroll>
              </div>
              <div className="clear"></div>
            </div>
            <div className="vod_loading">
              <img src={imgUrl + '/img/vod/vod_loading.png'} />
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyDown));
